import axios from '../../axios';
import { GetInvoicePaymentResponse } from '../../../models/dtos/getInvoicePayment.dto';
export default async function getInvoicePaymentRepository(
  startDate: String,
  endDate: String
): Promise<GetInvoicePaymentResponse> {
  const res = await axios.get<GetInvoicePaymentResponse>(
    `${process.env.REACT_APP_BASE_URL}/financial-operation/invoice-payment`,
    {
      params: {
        startDate,
        endDate,
      },
    }
  );
  return res.data;
}
